const NotFound = () => {
    return (
    <div>
      <p>This is the 404</p>
    </div>);
  };
  
  export default NotFound;
  